export default __webpack_public_path__ + "cb11eb25ab108343941825c6c09b433f.png";